export default "__VITE_ASSET__DKsKi78M__"